// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBox_container__3ylr2","childContainer":"NotificationBox_childContainer__3QmYc"};